import React from "react";
import { Link } from "react-router-dom";

//COMPONENTS
import ServicesLaptop from "../components/home/ServicesLaptop";
import ServicesMobile from "../components/home/ServicesMobile";
import Cta from "../components/Cta";

//ASSETS
import Hummingbird from "../assets/hummingbird.svg"
import ImgPlaceholder from "../assets/team.jpg"

const Home = () => {
  return (
    <div>
      {/* START HEADER */}
      <div className="bg-darkBlue">
        <div className="max-w-7xl mx-auto px-4 sm:px-6">
          <div className="pt-20 pb-40 flex items-center justify-center lg:justify-between lg:space-x-10">
            <div className="flex-1 max-w-xl text-center lg:text-left">
              <h1 className="header1 text-3xl">
                Your Business,
                <br/>
                <span className="text-earth">Our Passion.</span>
              </h1>
              <div className="my-8 text-lg text-lightGrey">
                Helping businesses to grow is our passion and through our business advisory services we offer private investments for the right opportunities to help your business to flourish.
              </div>
              <Link
                to="/contact"
                className="mt-8 bg-earth rounded-md shadow-md py-4 px-8 whitespace-nowrap text-xl font-medium text-white"
              >
                Let's talk
              </Link>
            </div>
            <div className="hidden lg:block lg:flex-1">
              <img src={ImgPlaceholder} alt="placeholder" class="rounded-lg"/>
            </div>
          </div>
        </div>
      </div>
      <div className="relative -mt-16 mb-20">
        <div className="max-w-7xl mx-auto px-4 sm:px-6">
          <div className="rounded-lg shadow-lg bg-earth">
            <div className="text-white text-center grid grid-rows-2 grid-cols-3 gap-8 items-center py-8 px-8 sm:gap-8 md:grid-cols-5 md:grid-rows-1 md:gap-16">
              <div className="md:col-start-1">Finances</div>
              <div className="col-start-1 row-start-2 md:col-start-2 md:row-start-1">
                Business
              </div>
              <div className="text-white mx-auto col-start-2 row-span-2 sm:w-24 md:col-start-3 md:row-span-1">
                <img src={Hummingbird} alt="Nectar Hummingbird"/>
              </div>
              <div className="col-start-3 md:col-start-4">Investing</div>
              <div className="col-start-3 row-start-2 md:col-start-5 md:row-start-1">
                Opportunity
              </div>
            </div>
          </div>
        </div>
      </div>
      {/* END HEADER */}
      <div className="max-w-7xl mx-auto px-4 sm:px-6">
        <p className="text-darkGrey text-xl text-center mt-20">
          Investments & Acquisitions, Business Advisory services, Payroll and HR solutions is our specialisation, 
          built of over 30 years’ experience in the game. We’re on a mission to make our clients life’s easier and 
          to help them develop.
        </p>
      </div>
      <ServicesLaptop />
      <ServicesMobile />
      <Cta />
    </div>
  );
};

export default Home;
